
import React, { useState } from 'react';
import '../Maintenance-styles/modalSelector.css';

const SelectorHostModal = ({ hosts = [], onClose, onSelectHost }) => {
  // Estado para almacenar el término de búsqueda
  const [searchTerm, setSearchTerm] = useState('');

  // Filtrar los hosts según el término de búsqueda
  const filteredHosts = hosts.filter((host) =>
    host.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="modal">
      <button className="close-modal-button" onClick={onClose}>
        &times;
      </button>
      <h2>Seleccionar Host</h2>

      <input
        type="text"
        className="input search-host"
        placeholder="Buscar host..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)} // Actualizar el término de búsqueda
      />

      <div className="modal-select-list">
        {filteredHosts.map((host) => (
          <div
            key={host.hostid || host.name} // Aseguramos que cada host tenga una key única
            className="select-item"
            onClick={() => {
              onSelectHost(host);
              onClose();
            }}
          >
            {host.name}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectorHostModal;
